import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import { Loading } from './Loading'
import { RenderIf } from '../helpers/RenderIf';

const AuthBody = ({ children, showLoading = false }) => {
	return (
		<Container fluid>
			<Row className="px-0">
				<Col md={5} className="d-none d-lg-block px-0">
					<div className="login-pic vh-100" />
				</Col>
				<Col md={7} className="px-0 bg-white">
					<div className="text-center">
						<div className="d-flex vh-100 p-sm-3 p-3 align-items-md-center justify-content-center">
							<RenderIf condition={!showLoading}>
								{children}
							</RenderIf>
							<RenderIf condition={showLoading}>
								<div className="d-flex align-items-center">
									<Loading
										showLoading={showLoading}
									/>
								</div>
							</RenderIf>
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
}

export default AuthBody;
